var _excluded = ["t", "entity", "customClasses", "values"];
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React, { Component } from 'react';
import config from 'react-global-configuration';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import c from 'classnames';
import { Field } from 'formik';
var WEBFORM_DEFAULT_FILE_EXTENSIONS = 'gif jpg jpeg png bmp eps tif pict psd txt rtf html odf pdf doc docx ppt pptx xls xlsx xml avi mov mp3 mp4 ogg wav bz2 dmg gz jar rar sit svg tar zip';
var WebformFileUpload = /*#__PURE__*/function (_Component) {
  _inherits(WebformFileUpload, _Component);
  var _super = _createSuper(WebformFileUpload);
  function WebformFileUpload(props) {
    var _this;
    _classCallCheck(this, WebformFileUpload);
    _this = _super.call(this, props);
    _defineProperty(_assertThisInitialized(_this), "getAllowedFileExtensions", function () {
      var entity = _this.props.entity;
      return entity.get('#file_extensions', WEBFORM_DEFAULT_FILE_EXTENSIONS);
    });
    _defineProperty(_assertThisInitialized(_this), "uploadFile", function (files, values, key, multiple) {
      var _this$props = _this.props,
        language = _this$props.language,
        id = _this$props.id;
      var API_URL = config.get('API_URL');
      var MULTILINGUAL = config.get('MULTILINGUAL', true);
      var PATH = MULTILINGUAL ? "".concat(API_URL, "/").concat(language) : API_URL;
      var uploadedFiles;
      if (multiple) {
        uploadedFiles = [];
      }
      var that = _assertThisInitialized(_this);
      files.map(function (file, index) {
        var formData = new FormData();
        formData.append("".concat(file.name), file);
        var reader = new FileReader();
        reader.onload = function (event) {
          var contents = event.target.result;
          fetch("".concat(PATH, "/session/token"), {
            credentials: 'include'
          }).then(function (response) {
            return response.text();
          }).then(function (response) {
            var csrfToken = response;
            fetch("".concat(PATH, "/webform_rest/").concat(id, "/upload/").concat(key, "?_format=json"), {
              method: 'POST',
              credentials: 'include',
              headers: {
                'Content-Type': 'application/octet-stream',
                'Content-Disposition': "file; filename=\"".concat(file.name, "\""),
                'X-CSRF-Token': csrfToken
              },
              body: contents
            }).then(function (response) {
              return response.json();
            }).then(function (response) {
              if (response && response.fid) {
                // Do something with the successful response
                if (multiple) {
                  uploadedFiles.push(response.fid[0].value);
                } else {
                  uploadedFiles = response.fid[0].value;
                }
                values[key] = uploadedFiles;
                that.props.validateField(key);
              } else {
                that.setState({
                  fileErrors: _defineProperty({}, file.name, true)
                });
              }
            }).catch(function (error) {
              console.log(error);
            });
          });
        };
        reader.readAsArrayBuffer(file);
      });
    });
    _defineProperty(_assertThisInitialized(_this), "addFile", function (key, values, title, multiple) {
      var files = Object.entries(_this.fileInput.current.files);
      var newFilesArray = [];
      for (var i = 0; i < files.length; i++) {
        var file = files[i];
        if (_this.getAllowedFileExtensions().indexOf(file[1].name.split('.').pop()) === -1) {
          continue;
        }
        newFilesArray.push(file[1]);
      }
      _this.setState(function (prevState) {
        return {
          files: [].concat(_toConsumableArray(prevState.files), newFilesArray)
        };
      });
      _this.uploadFile(newFilesArray, values, key, multiple);
    });
    _defineProperty(_assertThisInitialized(_this), "removeFile", function (key, index, values) {
      // eslint-disable-next-line react/no-access-state-in-setstate
      var stateFiles = _this.state.files;
      if (Array.isArray(values[key])) {
        values[key].splice(index, 1);
      } else {
        values[key] = [];
      }
      stateFiles.splice(index, 1);
      _this.setState({
        files: stateFiles
      }, function () {
        _this.props.setFieldValue(_this.props.entity.get('#webform_key'), values[key]);
        _this.forceUpdate();
      });
    });
    _defineProperty(_assertThisInitialized(_this), "validate", function (value) {
      var _this$props2 = _this.props,
        t = _this$props2.t,
        entity = _this$props2.entity;
      var required = entity.get('#required', false);
      if (required) {
        if (!value || Array.isArray(value) && value.length === 0) {
          return t(['webform.required']);
        }
      }
    });
    _this.state = {
      files: []
    };
    _this.fileInput = /*#__PURE__*/React.createRef();
    return _this;
  }
  _createClass(WebformFileUpload, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props3 = this.props,
        t = _this$props3.t,
        entity = _this$props3.entity,
        customClasses = _this$props3.customClasses,
        values = _this$props3.values,
        fieldProps = _objectWithoutProperties(_this$props3, _excluded);
      var files = this.state.files;
      var wrapperClassNames = c('WebformFileUpload', entity.getIn(['#wrapper_attributes', 'class', 0], ''));
      var labelClassNames = c('WebformFileUpload__label', entity.getIn(['#label_attributes', 'class', 0], ''));
      var elementClassNames = c('WebformFileUpload__input', entity.getIn(['#attributes', 'class', 0], ''));
      var title = entity.get('#title');
      var required = entity.get('#required', false);
      var description = entity.get('#description');
      var key = entity.get('#webform_key');
      var multiple = entity.get('#webform_multiple');
      var errorId = "".concat(key, "--error");
      var descriptionId = "".concat(key, "--description");
      var fieldError = fieldProps.errors[key];
      var isTouched = fieldProps.touched[key];
      return /*#__PURE__*/React.createElement("div", {
        className: wrapperClassNames
      }, title && /*#__PURE__*/React.createElement("label", {
        className: labelClassNames,
        htmlFor: key
      }, title, "  ", !required && '(optioneel)'), /*#__PURE__*/React.createElement("div", {
        className: "WebformFileUpload__uploaded-files"
      }, files && files.map(function (e, i) {
        return /*#__PURE__*/React.createElement("div", {
          className: "WebformFileUpload__uploaded-file",
          key: e.name
        }, /*#__PURE__*/React.createElement("div", {
          className: "WebformFileUpload__uploaded-file__wrapper"
        }, /*#__PURE__*/React.createElement("div", {
          className: "WebformFileUpload__icon icon-before icon-checkmark"
        }), /*#__PURE__*/React.createElement("div", {
          className: "WebformFileUpload__uploaded-file__text-container"
        }, /*#__PURE__*/React.createElement("div", {
          className: "WebformFileUpload__uploaded-file__title"
        }, e.name), /*#__PURE__*/React.createElement("div", {
          className: "WebformFileUpload__uploaded-file__remove",
          onClick: function onClick() {
            _this2.removeFile(key, i, values);
          }
        }, t(['webform.components.file_upload.remove_file'])))));
      })), /*#__PURE__*/React.createElement(Field, {
        className: elementClassNames,
        type: "file",
        id: key,
        name: key,
        value: undefined,
        multiple: multiple,
        innerRef: this.fileInput,
        onChange: function onChange() {
          _this2.addFile(key, values, title, multiple);
        },
        onClick: function onClick(event) {
          /* Allow re-selecting files */event.target.value = [];
        },
        accept: this.getAllowedFileExtensions().replace(' ', ',.').replace(/^/, '.'),
        validate: this.validate,
        required: required,
        "aria-describedby": "".concat(errorId, " ").concat(descriptionId),
        "aria-invalid": Boolean(fieldError && isTouched)
      }), (multiple === true || files < 1) && /*#__PURE__*/React.createElement("label", {
        htmlFor: key,
        className: "WebformFileUpload__link"
      }, multiple ? t(['webform.components.file_upload.button_plural', 'webform.components.file_upload.button']) : t(['webform.components.file_upload.button'])), /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, description && /*#__PURE__*/React.createElement("div", {
        id: descriptionId,
        className: "col-8 WebformFileUpload__description"
      }, description)), fieldError && isTouched ? /*#__PURE__*/React.createElement("div", {
        id: errorId,
        className: "WebformFileUpload__error"
      }, fieldError) : null);
    }
  }]);
  return WebformFileUpload;
}(Component);
/**
 * @param state
 * @param ownProps
 */
function mapStateToProps(state, ownProps) {
  return {
    language: state.getIn(['ui', 'language'])
  };
}
export default connect(mapStateToProps)(withTranslation()(WebformFileUpload));